import MenuSelector from "@arelia-components/ui-atoms/menu-selector/MenuSelector";
import { MenuType } from "@arelia-components/ui-atoms/menu-selector/models";
import { formatDate } from "@arelia-utils/helpers/dates";
import { Box, Checkbox, FormControl, InputLabel, ListItemText, MenuItem, OutlinedInput, Select, SelectChangeEvent } from "@mui/material";
import { sortByMenu } from "./constants";
import { RoyaltiesEarningsSorting } from "./models";

type Props = {
  sortRoyaltiesBy: RoyaltiesEarningsSorting;
  setSortRoyaltiesBy: (value: RoyaltiesEarningsSorting) => void;

  uniquePeriods: string[];
  selectedPeriods: string[];
  setSelectedPeriods: (value: string[]) => void;

  uniqueSources: string[];
  selectedSources: string[];
  setSelectedSources: (value: string[]) => void;

  uniqueSongs: (string | undefined)[];
  selectedSongs: string[];
  setSelectedSongs: (value: string[]) => void;
}

export default function RoyalatiesDetailsTableFilters({
  setSortRoyaltiesBy,
  sortRoyaltiesBy,

  uniquePeriods,
  selectedPeriods,
  setSelectedPeriods,

  uniqueSources,
  selectedSources,
  setSelectedSources,

  uniqueSongs,
  selectedSongs,
  setSelectedSongs
}: Props) {
  const handlePeriodChange = (event: SelectChangeEvent<string[]>) => {
    setSelectedPeriods(event.target.value as string[]);
  };
  const handleSourceChange = (event: SelectChangeEvent<string[]>) => {
    setSelectedSources(event.target.value as string[]);
  };
  const handleSongChange = (event: SelectChangeEvent<string[]>) => {
    setSelectedSongs(event.target.value as string[]);
  };

  return (
    <Box sx={styles.filters}>
      <MenuSelector
        menuType={MenuType.contained}
        menuItems={sortByMenu}
        selectedValue={sortRoyaltiesBy}
        onClick={setSortRoyaltiesBy}
      ></MenuSelector>

      <FormControl sx={{ width: 300 }} size="small">
        <InputLabel>Reported On</InputLabel>
        <Select
          multiple
          value={selectedPeriods}
          onChange={handlePeriodChange}
          input={<OutlinedInput label="Reported On" />}
          renderValue={(selected) => selected.map(period => formatDate(period, "QQQ yyyy")).join(', ')}
          sx={styles.select}
        >
          {uniquePeriods.map((period, i) => (
            <MenuItem key={i} value={period}>
              <Checkbox checked={selectedPeriods.some(t => t === period)} />
              <ListItemText primary={formatDate(period, "QQQ yyyy")} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl sx={{ width: 300 }} size="small">
        <InputLabel>Source</InputLabel>
        <Select
          multiple
          value={selectedSources}
          onChange={handleSourceChange}
          input={<OutlinedInput label="Source" />}
          renderValue={(selected) => selected.join(', ')}
          sx={styles.select}
        >
          {uniqueSources.map((source, i) => (
            <MenuItem key={i} value={source}>
              <Checkbox checked={selectedSources.some(t => t === source)} />
              <ListItemText primary={source} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl sx={{ width: 300 }} size="small">
        <InputLabel>Songs</InputLabel>
        <Select
          multiple
          value={selectedSongs}
          onChange={handleSongChange}
          input={<OutlinedInput label="Source" />}
          renderValue={(selected) => selected.join(', ')}
          sx={styles.select}
        >
          {uniqueSongs.map((song, i) => (
            <MenuItem key={i} value={song}>
              <Checkbox checked={selectedSongs.some(t => t === song)} />
              <ListItemText primary={song} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}

const styles = {
  filters: {
    display: "flex",
    gap: "20px",
    alignItems: "center"
  },
  select: {
    bgcolor: 'white',
    margin: '0'
  }
}
